'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _consts = require('../consts.js');

var _ProviderIntent = require('../components/ProviderIntent.js');

var _ProviderIntent2 = _interopRequireDefault(_ProviderIntent);

var _providerEvents = require('wix-art-store-3rd-party/dist/src/sdk/providerEvents');

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _mobileViewTypes = require('wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes');

var _mobileViewTypes2 = _interopRequireDefault(_mobileViewTypes);

var _WixSDKProviderApi = require('../components/WixSDKProviderApi');

var _WixSDKProviderApi2 = _interopRequireDefault(_WixSDKProviderApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prop-types, no-case-declarations */
var FullScreenShop = function (_Component) {
  (0, _inherits3.default)(FullScreenShop, _Component);

  function FullScreenShop(props) {
    (0, _classCallCheck3.default)(this, FullScreenShop);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullScreenShop.__proto__ || (0, _getPrototypeOf2.default)(FullScreenShop)).call(this, props));

    _this.state = { providerShopHeight: null };
    return _this;
  }

  (0, _createClass3.default)(FullScreenShop, [{
    key: 'postShopRequest',
    value: function postShopRequest(type, data) {
      if (this.shopIntent) {
        this.shopIntent.postMessage(type, data);
      }
    }
  }, {
    key: 'addToCartRequest',
    value: function addToCartRequest() {
      if (this.shopIntent) {
        this.shopIntent.postMessage(_providerEvents2.default.addToCartRequest, {});
      }
    }
  }, {
    key: 'sendItemData',
    value: function sendItemData(item) {
      if (item && item.getDataForShop) {
        this.shopIntent.postMessage(_providerEvents2.default.itemChanged, item.getDataForShop());
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var item = nextProps.item;
      if (item) {
        if (this.shopIntent) {
          if (this.props.item && this.props.item.id !== item.id) {
            this.sendItemData(item);
          }
        }
      }
    }
  }, {
    key: 'messageReceived',
    value: function messageReceived(type, payload, resolve, reject, providerId) {
      var _props = this.props,
          galleryId = _props.galleryId,
          styleId = _props.styleId,
          pageId = _props.pageId,
          storeApi = _props.storeApi,
          connectedProviders = _props.connectedProviders,
          toggleShopEditorPage = _props.toggleShopEditorPage,
          _props$item = _props.item,
          url = _props$item.url,
          isDemo = _props$item.isDemo,
          isOOI = _props.isOOI;

      switch (type) {
        case _providerEvents2.default.sdkReady:
          this.sendItemData(this.props.item);
          console.time('Provider items load time');
          break;
        case _providerEvents2.default.addToCart:
          var uuid = payload.uuid,
              quantity = payload.quantity,
              metadata = payload.metadata;

          storeApi.addToCart({
            uuid: uuid,
            itemUrl: url,
            galleryId: galleryId,
            providerId: providerId,
            quantity: quantity,
            isDemo: isDemo,
            metadata: metadata,
            styleId: styleId
          });
          resolve();
          break;
        case _providerEvents2.default.setHeight:
          if (payload.height !== this.state.providerShopHeight) {
            this.setState({ providerShopHeight: payload.height });
          }
          resolve();
          break;
        case _providerEvents2.default.close:
          this.props.toggleMobileShopFrame();
          break;
        case _providerEvents2.default.setMobileProductData:
          this.props.onSetMobileData(payload.type, payload.data);
          console.timeEnd('Provider items load time');
          break;
        case _providerEvents2.default.setDefaultPrice:
          var priceData = payload;
          this.props.onSetMobileData(_mobileViewTypes2.default.singleProduct, priceData);
          break;
        case _providerEvents2.default.openModal:
          var options = payload.options,
              name = payload.name;

          if (isOOI) {
            var provider = (0, _keys2.default)(connectedProviders)[0];
            var providerData = connectedProviders[provider];
            var widgets = providerData.widgets;

            if (widgets[name] && [_consts.providerIntents.editor].includes(name)) {
              toggleShopEditorPage((0, _extends3.default)({}, options, options.urlParams, { name: name }));
              resolve();
              break;
            }
          }
          storeApi.openProviderModal({
            name: name,
            connectedProviders: connectedProviders,
            options: options,
            containerParams: { galleryId: galleryId, itemUrl: url, isDemo: isDemo, styleId: styleId, pageId: pageId }
          });
          resolve();
          break;
        case _providerEvents2.default.updateCartItem:
          storeApi.updateCartItem({
            uuid: payload.uuid,
            metadata: payload.metadata,
            quantity: payload.quantity
          });
          break;
        case _providerEvents2.default.clearCart:
          storeApi.clearCart();
          break;
        case _providerEvents2.default.removeFromCart:
          storeApi.removeFromCart({ uuid: payload.uuid });
          break;
        case _providerEvents2.default.getCartItems:
          var items = this.props.cartItemsData.cartItems || [];
          resolve(items);
          break;
        default:
          break;
      }
    }
  }, {
    key: 'getShopHeight',
    value: function getShopHeight(isMobile) {
      var providerShopHeight = this.state.providerShopHeight;
      var storeHeight = this.props.storeHeight;

      var height = providerShopHeight ? Math.min(storeHeight, providerShopHeight) : storeHeight;
      return isMobile ? '100%' : height + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          wixSdk = _props2.wixSdk,
          additionalProviderParams = _props2.additionalProviderParams,
          item = _props2.item,
          galleryId = _props2.galleryId,
          isMobile = _props2.isMobile,
          consentPolicy = _props2.consentPolicy;

      var customAdditionalParams = {};
      consentPolicy && (customAdditionalParams.consentPolicy = consentPolicy);
      if (additionalProviderParams) {
        var srcId = additionalProviderParams.srcId,
            appDefId = additionalProviderParams.appDefId,
            isAlbumStore = additionalProviderParams.isAlbumStore,
            pricelistId = additionalProviderParams.pricelistId;

        srcId && (customAdditionalParams.srcId = srcId);
        pricelistId && (customAdditionalParams.pricelistId = pricelistId);
        appDefId && (customAdditionalParams.appDefId = appDefId);
        isAlbumStore && (customAdditionalParams.isAlbumsStore = isAlbumStore);
      }
      return _react2.default.createElement(
        'div',
        { className: 'full-screen-shop', style: { height: this.getShopHeight(isMobile) } },
        _react2.default.createElement(_ProviderIntent2.default, (0, _extends3.default)({
          api: new _WixSDKProviderApi2.default(wixSdk),
          ref: function ref(r) {
            return _this2.shopIntent = r;
          },
          intent: _consts.providerIntents.shop,
          tabIndex: 0,
          customAdditionalParams: customAdditionalParams,
          onMessageReceived: function onMessageReceived(type, payload, resolve, reject, providerId) {
            _this2.messageReceived(type, payload, resolve, reject, providerId);
          },
          additionalParams: (0, _extends3.default)({}, item.getDataForShop(), { galleryId: galleryId })
        }, this.props))
      );
    }
  }]);
  return FullScreenShop;
}(_react.Component);
/* eslint-enable react/prop-types, no-case-declarations */

exports.default = FullScreenShop;